<banner-app [retroSelected]="false" [infoDueno]="true"  [showPromo]="true"></banner-app>

<div class="mainContainer justify-content-center align-items-center">
  <div class="textContainer d-flex flex-column align-items-center">
    <h3 class="title">¡Ya tenemos tus datos!</h3>
    <h5 class="subtitle">
      Nos pondremos en contacto contigo para continuar con el proceso.
    </h5>
  </div>
  <img
    src="./assets/img/FeedBackManos.png"
    class="image"
    alt="seguro de moto precio" 
    loading="lazy"
  />
  <div
    *ngIf="!showInitialButtons; else initialButtons"
    id="principalButton"
    class="buttonsContainer d-flex justify-content-center mb-5"
  >
    <button
      class="btn btn-primary localButton backStartButton"
      (click)="volverIncio()"
      type="submit"
    >
      <strong>Volver al Inicio</strong>
    </button>
  </div>
</div>

<app-footer-app></app-footer-app>

<ng-template #initialButtons>
  <div class="buttonsContainer d-flex justify-content-between mb-5">
    <button
      class="btn btn-primary localButton suraButton"
      (click)="volverIncio()"
      type="submit"
    >
      <strong>Regresar a SURA</strong>
    </button>
    <button
      class="btn btn-primary localButton runtButton"
      (click)="irRunt()"
      type="submit"
    >
      <strong>Ir al RUNT</strong>
    </button>
  </div>
</ng-template>
